<template>
  <div class="container flex flex-col justify-between items-center">
    <component
      :is="element.component"
      v-for="(element, index) of schema"
      :key="index"
      :content="element.content"
    />
  </div>
</template>

<script>
const LogoBlock = ({ props }) => (
  <img
    class="md:h-12 w-auto inline-block ml-4 mr-6 mb-4"
    src={props.content}
    aria-hidden="true"
  />
)

const RowBlock = {
  functional: true,
  render(h, { props }) {
    return (
      <div class="flex flex-col md:flex-row -mx-4 flex-grow">
        {props.content.map((el) => (
          <el.component content={el.content} />
        ))}
      </div>
    )
  },
  props: { content: Array },
}

const NavBlock = {
  functional: true,
  render(h, { props }) {
    return (
      <div class="block mb-8 px-4 text-left w-full">
        <h2 class="text-base md:text-lg mb-4 md:h-8 block">
          {props.content.header}
        </h2>
        <ul>
          {props.content.links.map((link) => (
            <li>
              <a
                class="hover:underline text-sm mb-1 inline-block"
                href={link.url}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  },
  props: { content: Object },
}

const FreeFormBlock = {
  functional: true,
  render(h, { props }) {
    return h('div', {
      class: 'text-left block w-full px-4',
      domProps: {
        innerHTML: props.content,
      },
    })
  },
  props: { content: String },
}

const NewBlock = () => <div />

export default {
  components: {
    LogoBlock,
    FreeFormBlock,
    NavBlock,
    RowBlock,
    NewBlock,
  },
  props: {
    schema: {
      type: Array,
      required: true,
    },
  },
}
</script>
